/* global L */

L.FontMarker = {
  defaultSmallIcon: 'circle',
  defaultSmallIconSize: 20,
  defaultColor: '#217BC9',
  defaultIcon: 'icon-annotation-map-marker',
  defaultIconColor: '#fff',
  defaultSize: 'm',
  defaultMarkerType: 'icon-marker-bg-layer',
  sizes: {
    s: {
      iconSize: 35,
      markerSize: [20, 35],
      wrapperSize: [35, 35],
      popupAnchor: [0, -35],
      labelAnchor: [4, -17]
    },
    m: {
      iconSize: 40,
      markerSize: [23, 40],
      wrapperSize: [60, 30],
      popupAnchor: [0, -40],
      labelAnchor: [6, -20]
    },
    l: {
      iconSize: 50,
      markerSize: [29, 50],
      wrapperSize: [50, 50],
      popupAnchor: [0, -50],
      labelAnchor: [8, -25]
    }
  }
};

L.FontMarker.Icon = L.Icon.extend({
  options: {
    smallIcon: L.FontMarker.defaultSmallIcon,
    smallIconSize: L.FontMarker.defaultSmallIconSize,
    // short or long form hex color code
    color: L.FontMarker.defaultColor,
    // Any font awesome icon class, number, or combination of 2 characters
    icon: L.FontMarker.defaultIcon,
    // short or long form hex color code
    iconColor: L.FontMarker.defaultIconColor,
    // 's' (small), 'm' (medium), or 'l' (large)
    size: L.FontMarker.defaultSize,
    markerType: L.FontMarker.defaultMarkerType,
    opacity: 1,
    shadowAnchor: null,
    shadowSize: null,
    shadowUrl: null,
    className: 'font-marker'
  },

  initialize: function (options) {
    options = L.Util.setOptions(this, options);
    if (typeof options.size === 'string') {
      L.extend(options, L.FontMarker.sizes[options.size]);
    } else {
      L.extend(options, options.size);
    }
  },

  createIcon: function () {
    var div = this._createWrapper();
    var marker = this._createMarker();
    var icon = this._createIcon();
    var smallIcon = this._createSmallIcon();

    div.appendChild(smallIcon);
    this._setSmallIconStyles(smallIcon);

    if (icon) {
      div.appendChild(icon);
      this._setIconStyles(icon);
    }

    div.appendChild(marker);

    this._setWrapperStyles(div);
    this._setMarkerStyles(marker);

    return div;
  },

  createShadow: function () {
    return null;
  },

  _setIconStyles: function (icon) {
    var options = this.options;
    var size = options.iconSize;

    icon.style.color = options.iconColor;
    icon.style.position = 'absolute';
    icon.style.fontSize = size + 'px';
    icon.style.top = '0px';

    if (this._isIconClass()) {
      icon.style.left = '72%';
      icon.style.transform = 'translateX(-45%)';
    } else {

    }
  },

  _setSmallIconStyles: function (icon) {
    var options = this.options;
    var size = options.smallIconSize;
    var markerSize = L.point(options.markerSize);

    icon.style.color = options.iconColor;
    icon.style.position = 'absolute';
    icon.style.fontSize = size + 'px';
    icon.style.top = (markerSize.y / 5 - 1) + 'px';
    icon.style.left = '76%';
    icon.style.transform = 'translateX(-45%)';
  },

  _setMarkerStyles: function (marker) {
    var options = this.options;
    var size = L.point(options.markerSize);

    marker.style.color = options.color;
    marker.style.display = 'block';
    marker.style.fontSize = size.y + 'px';
    marker.style.height = size.y + 'px';
    marker.style.margin = '0 auto';
    marker.style.width = size.x + 'px';
  },

  _setWrapperStyles: function (div) {
    var options = this.options;
    var size = L.point(options.wrapperSize);

    div.style.height = size.y + 'px';
    div.style.marginLeft = (-size.x / 2 + 7) + 'px';
    div.style.marginTop = (-size.y) + 'px';
    div.style.opacity = options.opacity;
    div.style.width = (size.x / 2) + 'px';
  },

  /**
   * Create the inner icon
   *
   * @returns {Object} HTML DOM element
   */
  _createIcon: function () {
    var icon, type;
    var options = this.options;


    if (options.icon) {
      icon = document.createElement('i');

      if (this._isIconClass()) {
        type = 'fa-' + options.icon;
        icon.className = ['fa', type].join(' ');
      } else {
        icon.style.fontStyle = 'normal';
        icon.style.fontWeight = 'bold';
        icon.innerHTML = options.icon;
      }
    }

    return icon;
  },

  _createSmallIcon: function () {
    var type, icon = document.createElement('i');

    type = 'fa-' + this.options.smallIcon;
    icon.className = ['fa', type].join(' ');
    return icon;
  },

  /**
   * Create the marker icon
   *
   * @returns {Object} HTML DOM element
   */
  _createMarker: function () {
    var type, marker = document.createElement('i');

    type = 'fa-' + this.options.markerType;
    marker.className = ['fa', type].join(' ');
    return marker;
  },

  /**
   * Create icon wrapper
   *
   * @returns {Object} HTML DOM element
   */
  _createWrapper: function () {
    var options = this.options;
    var div = document.createElement('div');
    div.className = 'leaflet-marker-icon ' + (options.className || '');
    return div;
  },

  _isIconClass: function () {
    var options = this.options;
    var regex = /^\d+$|^[a-zA-Z]{1,2}$/i;
    return !regex.test(options.icon);
  }

});

L.FontMarker.icon = function (options) {
  return new L.FontMarker.Icon(options);
};

module.exports = L.FontMarker;



// WEBPACK FOOTER //
// ./~/@skycatch/skydash-saturn/boosters/map/src/app/leaflet/FontMarker.js